
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import { BDropdown } from 'bootstrap-vue'

@Component
export default class DateRangeFilter extends Vue {
  @Prop() label!: string
  @Prop() fieldName!: string
  @Ref() readonly dropdown!: BDropdown

  startDate = ''
  endDate = ''

  get hasFilter (): boolean {
    return !!(this.startDate || this.endDate)
  }

  clearFilter (): void {
    this.startDate = ''
    this.endDate = ''
    this.applyFilter()
  }

  applyFilter (): void {
    this.dropdown.hide(true)
    this.$emit('on-apply', [
      { filterName: `${this.fieldName}_after`, value: this.startDate },
      { filterName: `${this.fieldName}_before`, value: this.endDate }
    ])
  }
}
